import { useMutation } from '@apollo/client';
import { AptunoApolloLink, ResponseApolloErrorMapping } from '@contexts/Shared';
import {
  InitializeMoralRiskStudyRequestDto,
  InitializeMoralRiskStudyResponseDto,
  mapInitializeMoralRiskStudyCommandToDto,
} from '../dtos';
import { initializeMoralStudy } from '../schemas';
import {
  InitializeMoralRiskStudyCommand,
  InitializeMoralRiskStudyT,
  MoralRiskStudyCommandActions,
} from './../../../domain';

export const GqlMoralRiskStudyCommandActions: MoralRiskStudyCommandActions = {
  useInitializeMoralRiskStudy: (): InitializeMoralRiskStudyT => {
    const [action, { loading, data, error }] = useMutation<
      InitializeMoralRiskStudyResponseDto,
      InitializeMoralRiskStudyRequestDto
    >(initializeMoralStudy, {
      errorPolicy: 'all',
      context: { clientName: AptunoApolloLink.CREDIT_STUDY },
    });

    return {
      loading,
      error: error && ResponseApolloErrorMapping(error),
      initializedMoralRiskStudy: data?.initializeMoralStudy.value,
      initializeMoralRiskStudy: (command: InitializeMoralRiskStudyCommand) =>
        action({ variables: mapInitializeMoralRiskStudyCommandToDto(command) }),
    };
  },
};
